<template>
    <v-container>
        <div class="dash__welcome">
            <h1 class="font-thick">{{ welcome_message }},</h1>
            <h1 class="font-thick">{{ user_name }}</h1>
        </div>
        <v-container class="dash__widgets">
            <div class="dash__widgets--left">
                <WeatherWidget class="mb-5 mt-5 dash-shadow" />
                <!-- <Top10Widget />
                    <InfoCard /> -->
                <v-container v-if="!userHasAtleastOneFeature">
                    <SolidButton
                        class="long-bar"
                        to="report-bug"
                        text="Report Bug"
                    />
                </v-container>

                <v-container v-else>
                    <DesignCard class="dash-shadow" />
                </v-container>
            </div>
            <div class="dash__widgets--right">
                <NotificationWidget class="notification-widget dash-shadow" />
            </div>
        </v-container>
    </v-container>
</template>

<script>
import { computed, defineComponent } from "vue";
import WeatherWidget from "@/components/WeatherWidget.vue";
// import Top10Widget from "../components/Top10Widget.vue";
// import InfoCard from "../components/InfoCard.vue";
import SolidButton from "@/components/SolidButton.vue";
import DesignCard from "../components/DesignCard.vue";
import store from "@/store";
import NotificationWidget from "../components/NotificationWidget.vue";

export default defineComponent({
    name: "DashboardView",

    components: {
        WeatherWidget,
        // Top10Widget,
        // InfoCard,
        DesignCard,
        NotificationWidget,
        SolidButton,
    },

    setup() {
        const user_name = computed(() => store.state.user?.name);
        const welcome_messages = [
            "Welcome",
            "Welkom",
            "Hola",
            "Aloha",
            "Bonjour",
            "Namaste",
            "Selamat Datang",
        ];
        const welcome_message =
            welcome_messages[
                Math.floor(Math.random() * welcome_messages.length)
            ];

        const userHasAtleastOneFeature = computed(
            () => store.state.user?.features?.length >= 1 || false
        );

        return {
            user_name,
            welcome_message,
            userHasAtleastOneFeature,
        };
    },
});
</script>

<style lang="scss" scoped>
.dash-shadow {
    box-shadow: -1px 10px 20px -2px rgba(0, 0, 0, 0.26);
    -webkit-box-shadow: -1px 10px 20px -2px rgba(0, 0, 0, 0.26);
    -moz-box-shadow: -1px 10px 20px -2px rgba(0, 0, 0, 0.26);
}
.dash__widgets {
    display: flex;
    flex-direction: row;
    &--left {
        width: 344px;
    }
    &--right {
    }
}

.long-bar {
    width: 100%;
}
</style>
